import { BCDataGrid } from '@bimser/components';
import React from 'react';

export const useDMGridEventListener = (
	name: BCDataGrid.Entities.DataGrids,
	dxDataGridRef: React.RefObject<BCDataGrid.Entities.BCDataGridRef>
) => {
	React.useEffect(
		() =>
			BCDataGrid.Helpers.EventEmitter.listen(name, [
				{
					name: 'DMExplorer.LoadState' as unknown as BCDataGrid.Entities.EventEmitterTypes,
					handler: {
						next(state: string) {
							dxDataGridRef.current?.instance().state(JSON.parse(state));
						}
					}
				},
				{
					name: 'DMExplorer.RefreshAndClearSelection' as unknown as BCDataGrid.Entities.EventEmitterTypes,
					handler: {
						next() {
							dxDataGridRef.current?.instance().clearSelection();
							dxDataGridRef.current?.instance().refresh();
						}
					}
				},
				{
					name: 'DMExplorer.ClearAllAndRefresh' as unknown as BCDataGrid.Entities.EventEmitterTypes,
					handler: {
						next() {
							dxDataGridRef.current?.instance().clearSelection();
							dxDataGridRef.current?.instance().pageIndex(0);
							dxDataGridRef.current?.instance().clearFilter();
							dxDataGridRef.current?.instance().clearSorting();
							dxDataGridRef.current?.instance().refresh();
						}
					}
				},
				{
					name: 'DMExplorer.ClearSelection' as unknown as BCDataGrid.Entities.EventEmitterTypes,
					handler: {
						next() {
							dxDataGridRef.current?.instance().clearSelection();
						}
					}
				}
			]),
		[]
	);
};
